import React from 'react';
import googlescholar from './google-scholar.svg';

const IconGooglescholar = () => (
  <div>
    <img src={googlescholar} alt="googlescholar" />
  </div>
);

export default IconGooglescholar;
